export default "__VITE_ASSET__CQDiiDZb__"